import React,{Component} from "react";
import {  Row, Col, Card, CardHeader, CardBody, Button ,
 Form,
  FormInput,
  FormGroup,
 
   ListGroup,
  ListGroupItem,
   } from "shards-react";


import firebase from '../firebase';
import { AtomSpinner } from 'react-epic-spinners';
import { toast } from 'react-toastify';


export default class AddExam extends Component{

  constructor(props) {
    super(props);
  
    this.state = { examname:null,
                   subjects:[],
                  loading:false};
    this.setPassingMarks = this.setPassingMarks.bind(this);
    this.setTotalMarks = this.setTotalMarks.bind(this);
    this.get_subjects  = this.get_subjects.bind(this);
  }

  componentWillUnmount(){
      this.props.refresh();
  }

  get_subjects = () =>{
     var that = this;
      var subjects=[];
      this.setState({loading:false});
      firebase.firestore().collection('Subject').doc('list').get().then(function(docRef){
          var data = docRef.data().list;
          data.forEach(function(doc){              
              var sub_obj={
                total:0,
                passing:0,
                subjectname:doc.subjectname,
              };
              subjects.push(sub_obj);
          })
          that.setState({subjects:subjects,loading:false});
          console.log(that.state);
      })
  }

  AddExam = (evt) =>{
      var that = this;
      evt.preventDefault();

      for(var i=0;i<this.state.subjects.length;i++){
        if(isNaN(this.state.subjects[i].passing) || isNaN(this.state.subjects[i].total)){
            toast('Please Enter Numbers!', {containerId: 'A'});
            return;
        } 
      } 

      this.setState({loading:true});
      var func_ref = firebase.functions().httpsCallable('AddExam');
       func_ref({exam_name:this.state.examname,subjects:this.state.subjects}).then(function(result) {
                  // Read result of the Cloud Function.
                  var data = result.data;
                  console.log(data);
                  if(data.status==="success"){
                        console.log("Document succesfully added!");
                        toast('Exam  Added Successfully !', {containerId: 'A'});
                   }
                  else{
                        toast(data.error.message, {containerId: 'A'});
                        console.log(data.error.message);
                  }
                  that.setState({loading:false});

        }).catch(function(error) {
                  // Getting the Error details.
                  //var code = error.code;
                  var message = error.message;
                  //var details = error.details;
                  // ...
                  console.log(error);
                  that.setState({loading:false});
                  toast(message, {containerId: 'A'});
        });

      
  
  }

  componentDidMount(){
    this.get_subjects();
  }


  setPassingMarks = (marks,name) =>{
      console.log(name,marks);
      var sub_data = this.state.subjects;

      for(var i=0;i<sub_data.length;i++){
        if(sub_data[i].subjectname===name){
            sub_data[i].passing = marks;
        }
      }
      this.setState(sub_data);
      console.log(this.state);
  }

  setTotalMarks = (marks,name) =>{
      console.log(name,marks);
      var sub_data = this.state.subjects;

      for(var i=0;i<sub_data.length;i++){
        if(sub_data[i].subjectname===name){
            sub_data[i].total = marks;
        }
      }

      this.setState(sub_data);
      console.log(this.state);
  }

  render(){
    return(

  <Card small className="h-100" style={{margin:"5%"}}>
        <CardHeader className="border-bottom">
          <h6 className="m-0">Add New Exam</h6>
        </CardHeader>
        <CardBody className="pt-0">
          <ListGroup flush>
    <ListGroupItem className="p-3">
      <Row>
        <Col>
          
          <Form onSubmit={this.AddExam}>        
           

            <FormGroup>
              <label htmlFor="feInputExamname" style={{color:'blue'}}>Exam Name</label>
              <FormInput id="feInputExamName" 
                        placeholder="Exam Name" 
                        onChange={(evt)=>{this.setState({examname:evt.target.value})}} 
                />
            </FormGroup>
          

            {
                    this.state.subjects.map((item,i)=>{
                      return <Subject  name={item.subjectname} 
                                    key={i} 
                                    index={i+1} 
                                    setPassingMarks={(marks,name)=>{this.setPassingMarks(marks,name)}}
                                    setTotalMarks={(marks,name)=>{this.setTotalMarks(marks,name)}}
                                />
                    })
            }

            { this.state.loading && 
                <div style={{margin: '15%',marginLeft:'40%'}}>
                  <AtomSpinner color="blue" />
                </div>
            }
           

            
            <Button type="submit">Add new Exam</Button>
            <Button type="button" style={{marginLeft: '5%'}} theme="danger" onClick={()=>this.props.cancel()}>Cancel</Button>
            
          </Form>
        </Col>
      </Row>
    </ListGroupItem>
  </ListGroup>
        </CardBody>
      </Card>
        
    )
  }
}

class Subject extends Component{

    render(){
      return(
      <div>
           
             <Row form>
                <Col md="6">

                  <FormGroup>
                            <label htmlFor="feInputClassname" style={{color:'blue'}}>{this.props.name}</label>
                            <FormInput placeholder="Passing Marks" onChange={(evt) => {this.props.setPassingMarks(evt.target.value,this.props.name)}} />
                  </FormGroup>
                </Col>
                <Col md="6" className="form-group">
                    <FormGroup>
                            <label htmlFor="feInputClassname" style={{color:'blue'}}>{"Marks"}</label>
                            <FormInput placeholder="Total Marks" onChange={(evt) => {this.props.setTotalMarks(evt.target.value,this.props.name)}} />
                    </FormGroup>
                     
                </Col>
            </Row>
          </div>
  )
    }
}